import { httpClient } from "@coworker/http-client";
import { useQuery } from "@tanstack/react-query";
import type { LaunchMedia } from "../types/launch";

const mediaQueryKey = (mediaId: string | undefined) =>
  ["launch-media", "medias", mediaId] as const;

export function useMedia(mediaId: string | undefined) {
  return useQuery({
    queryKey: mediaQueryKey(mediaId),
    queryFn: async () => {
      const response = await httpClient.mediaMgmt.get<
        LaunchMedia | { media: LaunchMedia }
      >(`/medias/${encodeURIComponent(mediaId!)}`);
      return "media" in response ? response.media : response;
    },
    enabled: !!mediaId,
  });
}
